import { Handyman } from "@eljouren/domain/build";
import { useLocation } from "react-router-dom";
import AppArrowIcon from "../../../components/icons/AppArrowIcon";
import MyLink from "../../../components/routing/MyLink";
import AppRoutes from "../../../routes";

interface Props {
  className?: string;
  handyman: Handyman.Type;
}

const SalesTeamPartnerListItem = (props: Props) => {
  const location = useLocation();
  const params = new URLSearchParams({
    sida: "kalender",
    goBackTo: location.pathname + location.search,
  });

  const country = props.handyman.countryEnum;

  return (
    <li
      className="flex w-full cursor-pointer items-center justify-between rounded border bg-bg-base-layer transition-all hover:bg-main-bg-light/10"
      key={props.handyman.id}
    >
      <MyLink
        to={AppRoutes.salesTeam.singlePartner(props.handyman.id) + `?${params}`}
        className="flex w-full items-center gap-x-4 gap-y-1 p-2"
      >
        <img
          alt={`Flag for ${country}`}
          src={`flags/${country.toLowerCase()}.svg`}
          className="w-10 h-auto"
        ></img>
        <div className="flex flex-col">
          <span className="text-xl font-semibold">
            {props.handyman.firstName} {props.handyman.lastName}
          </span>
          <span className="text-lg">{props.handyman.companyName}</span>
        </div>
        <AppArrowIcon
          direction="right"
          size={24}
          className="ml-auto"
        />
      </MyLink>
    </li>
  );
};

export default SalesTeamPartnerListItem;
